import React, { Component } from 'react';
import moment from 'moment';
// import _ from 'underscore';
import './App.css';

import Nav from './pages/components/Nav.js'
import InstallPrompt from './pages/components/InstallPrompt';

import Home from './pages/Home.js';
import Login from './pages/Login.js'
import Signup from './pages/Signup.js'
import ResetPass from './pages/Reset.js'
import Forgot from './pages/Forgot.js'
import Dashboard from './pages/Dashboard.js'

import People from './pages/People.js'

import Admin from './pages/Admin.js'

import Lunch from './pages/Lunch.js'
import Coffee from './pages/Coffee.js'
import Confirm from './pages/Confirm.js'
import Done from './pages/Done.js'

import PoliDone from './pages/PoliDone.js'

import Report from './pages/Report.js'
import Ipad from './pages/Ipad.js'


class App extends Component {
  constructor(props) {
    super(props);

    this.polyFillArrayFind()

    this.registerServiceWorker();

    window.addEventListener("hashchange", this.handleHashChange.bind(this), false);

    var days = this.getDays();

    this.lastPage = null;

    var ua = navigator.userAgent,
        isAndroid = /Android/.test(ua),
        isChromeFirefox = /Chrome|Firefox/.test(ua),
        isCriOS = /CriOS/.test(ua);

    this.isCriOS = isCriOS;

    this.state = {
      loggedin: null,
      admin: false,
      page: this.parseHash(window.location.hash),
      days: days,
      savedCard: null,
      coffees: [],
      foods: [],
      people: [],
      schools: null,
      stripeKey: null,
      showDeviceAlert: (isAndroid && !isChromeFirefox) || isCriOS,
      disableCoffee: false,
      disableLunch: false,
      disablePoli: false,
      testMode: false,
      phone: '',
      order: {
        type: 'lunch',
        date: days[0],
        notes: '',
        customer: null,
        items: [],
        prevItems: [],
        payment: 'poli'
      }
    };

    this.getInitData();

    setInterval(this.getInitData.bind(this), 10 * 60 * 1000); // 10 min

    this.loginInterval = setInterval(this.tryLogin.bind(this), 1000)
    this.loginIntervalCount = 0

    this.tryLogin()
  }

  polyFillArrayFind(){
    if (!Array.prototype.find) {
      // eslint-disable-next-line
      Object.defineProperty(Array.prototype, 'find', {
        value: function(predicate) {
         // 1. Let O be ? ToObject(this value).
          if (this == null) {
            throw new TypeError('"this" is null or not defined');
          }

          var o = Object(this);

          // 2. Let len be ? ToLength(? Get(O, "length")).
          var len = o.length >>> 0;

          // 3. If IsCallable(predicate) is false, throw a TypeError exception.
          if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
          }

          // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
          var thisArg = arguments[1];

          // 5. Let k be 0.
          var k = 0;

          // 6. Repeat, while k < len
          while (k < len) {
            // a. Let Pk be ! ToString(k).
            // b. Let kValue be ? Get(O, Pk).
            // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
            // d. If testResult is true, return kValue.
            var kValue = o[k];
            if (predicate.call(thisArg, kValue, k, o)) {
              return kValue;
            }
            // e. Increase k by 1.
            k++;
          }

          // 7. Return undefined.
          return undefined;
        }
      });
    }
  }

  tryLogin(){
    this.loginIntervalCount += 1
    fetch('/api/user', {credentials: 'include'})
      .then(res => res.json())
      .then(user => {
        if(user){
          this.setUser(user);

          var redir = this.loginRedirect();
          if(redir)
            return window.location.href = redir;
        }
      })
      .catch(()=>{
        if(this.loginIntervalCount > 10)
          clearInterval(this.loginInterval)
        this.setState({loggedin:false})
        if(!(/login|signup|forgot/.test(window.location.hash)))
          window.location.href='/#/'
      })
  }

  registerServiceWorker(){
    if(!navigator.serviceWorker)
      return;
    if (navigator.serviceWorker.controller) {
      console.log(
          navigator.serviceWorker.controller.scriptURL +
          ' (onload)', 'controller');
      console.log(
        'An active service worker controller was found, ' +
        'no need to register');
    } else {
      navigator.serviceWorker.register('servwer.js', {
        scope: './'
      }).then(function(reg) {
        console.log(reg.scope, 'register');
        window.serwer = reg;
        console.log('Service worker change, registered the service worker');
      });
    }
  }

  getInitData(){
    fetch('/api/init')
      .then(res => {
        if(res.ok)
          return res.json()
        else
          throw new Error('Network response was not ok.');
      })
      .then(x=>{
        var order = this.state.order
        if(x.disablePoli && order.payment === 'poli')
          order.payment = (this.state.user && this.state.user.last4) ? 'saved' : 'newcard'
        this.setState(x)
      })
      // .then(()=>console.log('newState', this.state))
      .catch(error=> {
        console.log('error', error);
        this.setState({error: error.toString()})
      });
  }

  parseHash(hash){
    var parts = hash.match(/#\/(.*)\/?/);
    if(parts && parts[1].length)
      return parts[1];
    else
      return 'home';
  }

  loginRedirect(hash){
    if(!hash)
      hash = this.parseHash(window.location.hash);
    if(!this.state.loggedin && !(/home|login|signup|forgot.*/.test(hash))){
      return '#/login';
    }

    if(this.state.loggedin && /home|login|signup|forgot.*/.test(hash)) {
      return '#/dashboard';
    }

    if(['admin','ipad','report'].indexOf(hash) > -1 && !this.state.admin){
      return '#/dashboard';
    }
  }

  handleHashChange(){
    // console.log('hashchange');
    var hash = this.parseHash(window.location.hash);

    var redir = this.loginRedirect(hash);
    if(redir)
      return window.location.href = redir;

    if(hash === 'dashboard'){
      var order = this.state.order;
      order.items = [];
      order.id = null;
      if(this.state.savedCard)
        order.payment = 'saved';
      this.setState({order: order});
    }

    if(hash !== 'admin' && this.lastPage === 'admin')
      this.getInitData();

    this.lastPage = hash;

    // if(window.ga){
    //   window.ga('set', 'page', hash);
    //   window.ga('send', 'pageview');
    // }
    window.gtag && window.gtag('config', 'UA-113181579-1', {
      'page_title' : hash,
      'page_path': '/#/' + hash
    });

    this.setState({page: hash});
  }

  clearUser(){
    this.setState({
      savedCard: null,
      people: [],
      order: {
        type: 'lunch',
        date: this.getDays()[0],
        notes: '',
        customer: null,
        items: [],
        payment: this.state.disablePoli ? 'newcard' : 'poli'
      },
      loggedin: false,
      admin: false
    });
  }

  setUser(user){
    clearInterval(this.loginInterval)
    this.loginIntervalCount = 0

    var order = this.state.order,
      peeps = user.people.filter(p=>!p.removed);
    if(user.people.length)
      order.customer = peeps.length ? peeps[0] : null
    if(user.last4)
      order.payment = 'saved';
    this.setState({
      savedCard: user.last4,
      phone: user.phone,
      people: peeps,
      order: order,
      loggedin: true,
      admin: user.admin
    });
  }

  getDays(){
    var days = [
          {name: 'Today', date: moment().format()},
        ],
        notWeekend = x =>['Saturday','Sunday'].indexOf(name) < 0,
        hour = moment().hour(),
        minute = moment().minutes();
    if(!days.find)
      return [];
    var daysFuture = 1;
    while(days.length < 6){
      var day = moment().add(daysFuture++, 'days'),
          name = day.format('dddd');
      if(days.find(notWeekend))
        days.push({name: name, date: day.format()});
    }
    if(hour < 9 || (hour === 9 && minute < 15))
      days.pop();
    else
      days.shift();
    return days;
  }

  updateOrder(order, cb){
    this.setState({order: order}, cb);
    console.log('updated order', order)
  }

  getPage(){
    var poliMatch = this.state.page.match(/poli\/(.+)\/(.+)\?token=(.+)$/)
    if(poliMatch)
      return <PoliDone
        status={poliMatch[1]}
        orderId={poliMatch[2]}
        token={poliMatch[3]} />

    var resetMatch = this.state.page.match(/forgot\/(.+)$/);
    if(resetMatch)
      return <ResetPass
        setUser={this.setUser.bind(this)}
        token={resetMatch[1]} />;

    var peopts = {
      people: this.state.people,
      schools: this.state.schools,
      order: this.state.order,
      setState: this.setState.bind(this)
    }
    switch(this.state.page){
      case 'login':
        return <Login setUser={this.setUser.bind(this)} />;
      case 'signup':
        return <Signup setUser={this.setUser.bind(this)} />;
      case 'forgot':
        return <Forgot />;
      case 'dashboard':
        return <Dashboard
          popup={this.state.popup}
          promo={this.state.promo}
          disableCoffee={this.state.disableCoffee}
          disableLunch={this.state.disableLunch} />;
      case 'lunch':
        return this.state.people.length < 1 ?
          <People {...peopts} first={true} />
          : <Lunch order={this.state.order}
            updateOrder={this.updateOrder.bind(this)}
            days={this.state.days}
            foods={this.state.foods}
            people={this.state.people} />;
      case 'coffee':
        return this.state.people.length < 1 ?
          <People {...peopts} first={true} />
          : <Coffee coffees={this.state.coffees} order={this.state.order}
            updateOrder={this.updateOrder.bind(this)}
            people={this.state.people} />;
      case 'confirm':
        return <Confirm order={this.state.order}
          stripeKey={this.state.stripeKey}
          savedCard={this.state.savedCard}
          setState={this.setState.bind(this)}
          disablePoli={this.state.disablePoli}
          phone={this.state.phone}
          setPhone={(phone)=>this.setState({phone: phone})}
          updateOrder={this.updateOrder.bind(this)} />;
      case 'done':
        return <Done order={this.state.order} />;
      case 'report':
        return <Report />;
      case 'ipad':
        return <Ipad schools={this.state.schools}/>;
      case 'people':
        return <People {...peopts} />;
      case 'admin':
        return <Admin
          popup={this.state.popup}
          promo={this.state.promo}
          coffees={this.state.coffees}
          foods={this.state.foods}
          schools={this.state.schools}
          setState={this.setState.bind(this)} />;
      default:
        return <Home popup={this.state.popup}
          promo={this.state.promo}
        />;
    }
  }

  getCutoffWarning(){
    if(['home','login','signup','coffee','report','done'].indexOf(this.state.page) > -1)
      return;
    var hour = moment().hour(),
      minute = moment().minutes(),
      out;

      if (hour === 9 && minute < 15)
        out = 'Hurry! Lunch orders for today close at 9:15am';
      else if ((hour === 9 && minute >= 15) || hour > 9)
        out = 'Food orders have closed for today, but you can make an order for another day';

      return out ? <div className=""><br />
        <div className="alert alert-warning">{out}</div></div> : null;
  }

  getDeviceWarning(){
    return (<div className={this.state.page === 'home' ? "container" : ''} style={{
        marginTop: (this.state.page === 'home' ? '80px' : '10px'),
        zIndex: 20,
        position: 'relative'
      }}><div className="alert alert-warning">
        <button type="button" className="close" aria-label="Close"
          onClick={this.handleDismissDeviceAlert.bind(this)} >
          <span aria-hidden="true">&times;</span>
        </button>
        This app functions best in the
        {this.isCriOS ? ' Safari ' : ' Chrome '}
        browser. Please
        {this.isCriOS ? ' switch to Safari ' : ' download Chrome '}
        for the best experience. <br />
        {this.isCriOS ? null : (
          <a href="market://details?id=com.android.chrome&hl=en">
            Go to app store
          </a>
        )}
      </div></div>);
  }

  handleDismissDeviceAlert(e){
    e.preventDefault();
    this.setState({showDeviceAlert: false})
  }


  render() {

    if([this.state.loggedin, this.state.schools].indexOf(null) > -1){
      return (<h1>Loading...</h1>);
    }

    return (
      <div className="container">
        <div className="row">
          <div className={
            ['admin', 'ipad', 'report','home'].indexOf(this.state.page) > -1 ? '' :
            "col-sm-8 col-sm-offset-2 col-lg-6 col-lg-offset-3"}>
            <Nav admin={this.state.admin}
              page={this.state.page}
              testMode={this.state.testMode}
              clearUser={this.clearUser.bind(this)}/>
            { this.getCutoffWarning() }
            { this.state.showDeviceAlert ? this.getDeviceWarning() : null }
            { this.getPage() }
            <InstallPrompt />
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js